import { Button, Spin, Tooltip, Divider } from "antd";
import React, { useState, useEffect } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { notification } from "antd";
import { useNavigate, useParams } from "react-router";
import SectionHeader from "../../components/global/SectionHeader";
import ApiClient from "../../api/apiClient";
import moment from "moment";
import Layout from "../../components/global/layout";
import { BsArrowLeftSquare } from "react-icons/bs";

export default function ViewTask() {
  const [loading, setloading] = useState(false);
  const { id } = useParams();
  const [data, setdata] = useState([]);
  const history = useNavigate();
  const backfun = () => {
    history(-1);
  };
  const getdetails = () => {
    setloading(true);
    ApiClient.get(`task?id=${id}`)
      .then((res) => {
        setdata(res.data);
        setloading(false);
      })
      .catch((err) => {
        notification.error({ message: "Some error occurred.Try again" });
        setloading(false);
      });
  };
  useEffect(() => {
    getdetails();
  }, []);
  return (
    <Layout>
      <div>

        <div className="headings">
          <div className="d-flex align-items-center gap-3">
            <Tooltip title="Back Button">
              <p onClick={backfun} className="pointer text-white  fs-3">
                <BsArrowLeftSquare />
              </p>
            </Tooltip>
            <SectionHeader title="Task Details" />
          </div>
        </div>

        <div className="main-content">
          <section className="section">



            <Spin spinning={loading}>
              <div className="">
                <div className="">
                  {/* <div className="row">
                    <div className="col-md-12">
                      <label>Task Name :</label>
                      <span>{data?.taskName}</span>
                    </div>
                    <div className="col-md-4">
                      <label>Start Date : </label>
                      <span>
                        {moment(data?.assignDateAndTime).format("DD MMM YYYY")}
                      </span>
                    </div>
                    <div className="col-md-4">
                      <label>Expected Time : </label>
                      <span>
                        {data?.expectedhours} {data?.expectedminutes}
                      </span>
                    </div>
                    {data?.status == "done" ? (
                      <div className="col-md-4">
                        <label>Actual Time : </label>
                        <span>
                          {data?.Actual_hours} {data?.Actual_minutes}
                        </span>
                      </div>
                    ) : null}
                    <div className="col-md-4">
                      <label>Status : </label>
                      <span
                        className={`text-${data?.status == "inProgress"
                          ? "warning"
                          : data?.status == "done"
                            ? "success"
                            : "danger"
                          } text-capitalize`}
                      >
                        {data?.status}
                      </span>
                    </div>

                    <div className="col-md-12">
                      <label>Stories : </label>
                      <span>{data?.description}</span>
                    </div>
                    {data?.status == "Pending" ? (
                      <div className="col-md-12">
                        <label>Reason : </label>
                        <span>{data?.reason}</span>
                      </div>
                    ) : null}
                  </div> */}
                    <h6 className="detail-header"> <Divider orientation="left">Task Details</Divider></h6>
                  <div className="row m-0">
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Task-Name<span>:</span></label> <span> {data?.taskName}</span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Start Date<span>:</span></label> <span> {moment(data?.assignDateAndTime).format("DD MMM YYYY")}</span>                      </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Expected Time<span>:</span></label><span>  {data?.expectedhours} {data?.expectedminutes}</span>                     </li>
                    </div>
                    {data?.status == "done" ? (
                      <div className="col-md-6">
                        <li class="view_parent align-items-baseline">
                          <label className="detail-text text-bold text-capitalize pb-0">Actual Time<span>:</span></label><span>  {data?.Actual_hours} {data?.Actual_minutes}</span>                     </li>
                      </div>
                    ) : null}
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Status <span>:</span></label><span
                          className={`text-${data?.status == "inProgress"
                            ? "warning"
                            : data?.status == "done"
                              ? "success"
                              : "danger"
                            } text-capitalize`}
                        >
                          {data?.status}</span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Stories<span>:</span></label> <span>{data?.description}</span>                      </li>
                    </div>
                    {data?.status == "Pending" ? (
                      <div className="col-md-6">
                        <li class="view_parent align-items-baseline">
                          <label className="detail-text text-bold text-capitalize pb-0">Reason<span>:</span></label><span>  {data?.expectedhours} {data?.expectedminutes}</span>                     </li>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </Spin>
          </section>
        </div>
      </div>
    </Layout>
  );
}
